var map = {
	"./ActionsModal/Cambio.vue": 776,
	"./ActionsModal/SaveChanges.vue": 777,
	"./ActionsModal/index.vue": 246,
	"./agrocolor.vue": 2263,
	"./araporcei.vue": 2264,
	"./coplaca/ParcelasActionsMultiple.vue": 1161,
	"./coplaca/index.vue": 2265,
	"./default.vue": 2266,
	"./demo.vue": 2267,
	"./sites.vue": 292,
	"./widgets/auditorias.vue": 778,
	"./widgets/dictamenes.vue": 781,
	"./widgets/pacs.vue": 783,
	"./widgets/revisiones.vue": 780,
	"./widgets/solicitudes.vue": 779,
	"./widgets/toma_muestras.vue": 782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1898;